export const dataTriagemTipoReducer = (state, action) => {
  state.dataTriagem.tipos.data = action.payload.items;
  state.dataTriagem.ocorrencias.requestGetParams = action.meta.arg;
};

export const dataVariaveisTriagemStatusReducer = (state, action) => {
  state.dataTriagem.variaveis.data = action.payload.items;
};

export const dataTriagemIndicadoresTMSReducer = (state, action) => {
  const { items } = action.payload;
  const obj = items[0];
  state.dataTriagem.indicadores.data = {
    ...state.dataTriagem.indicadores.data,
    tmsOrigem: obj.tmsOrigem,
  };
};

export const dataTriagemIndicadoresCodigoOcorrenciaReducer = (
  state,
  action
) => {
  const { items } = action.payload;
  const obj = items[0];
  state.dataTriagem.indicadores.data = {
    ...state.dataTriagem.indicadores.data,
    pontos: obj.pontos,
  };
};

export const dataTriagemIndicadoresTipoReducer = (state, action) => {
  const { items } = action.payload;
  const obj = items[0];
  state.dataTriagem.indicadores.data = {
    ...state.dataTriagem.indicadores.data,
    tipoValidacao: obj.tipoValidacao,
  };
};

export const dataTriagemIndicadoresTransportadoraReducer = (state, action) => {
  const { items } = action.payload;
  const obj = items[0];
  state.dataTriagem.indicadores.data = {
    ...state.dataTriagem.indicadores.data,
    transportadoras: obj.transportadoras,
  };
};

export const dataTriagemOcorrenciasReducer = (state, action) => {
  state.dataTriagem.ocorrencias.data = action.payload.items;
  state.dataTriagem.ocorrencias.requestGetParams = action.meta.arg;
  state.dataTriagem.ocorrencias.pagination = {
    totalItems: action.payload.totalRegistros,
    totalPages: action.payload.totalPaginas,
  };
};
